import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router"
import { Observable } from "rxjs"
import { ClientService } from "../../../customer-area/shared/client/client.service"
import { OfflineService } from "../../../shared/offline.service"
import { AuthorizationService } from "./authorization.service"
import { Permissions } from "./permissions"

@Injectable({
  providedIn: "root"
})
export class AuthorizationGuardService  {

  isOnline: boolean = true

  constructor(
    protected router: Router,
    protected authorizationService: AuthorizationService,
    protected clientService: ClientService,
    private offlineService: OfflineService
  ) {
    this.offlineService.isOnline().subscribe(res => this.isOnline = res)
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(childRoute)
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {

    if (!this.isOnline) return false

    let role = route.data["role"] != undefined && route.data["role"].length !== 0 ? this.hasRequiredPermission(route.data["role"]) : true
    let notRole = !this.hasRequiredPermission([Permissions.ROLE_ADMINISTRATION]) && !this.hasRequiredPermission([Permissions.ROLE_ANETT]) && route.data["notRole"] != undefined && route.data["notRole"].length !== 0 ? this.hasRequiredPermission(route.data["notRole"]) : false

    if (notRole && route.data["redirect"] != undefined) {
      this.router.navigate(['/escli/' + route.data["redirect"]])
    }
    return role && !notRole
  }
  protected hasRequiredPermission(roles: Array<string>): boolean {
    let hasPermis: boolean = this.authorizationService.hasPermission(roles)
    return hasPermis
  }
}
